module.exports = __webpack_public_path__ + "img/address_map.976c77e8.png";